jQuery.fn.extend({
    act: function (options) {
        var act = {};
        act.instance = {};
        var settings = $.extend({ 
            headers : {}, 
            init : function(element){},
            respond : function(act, element, json){},
        }, options);

        settings.init(this);

        act.loading = function (element, status){

            const actualText = $('[type="submit"]', element).attr('actual-text');
            const loadingText = $('[type="submit"]', element).attr('loading-text');
 
            if(status === true){
                $(element).addClass('processing');
                if($(element).prop('tagName').toLowerCase() =='a'){
                    $(element).prop('disabled', true);
                }else{
                    $('[type="button"]', element).prop('disabled', true);
                    $('[type="submit"]', element).prop('disabled', true);
                    $('[type="reset"]', element).prop('disabled', true);    
                }
                $(element).removeClass('error-processing');
                $(element).removeClass('retry-processing');
                $('#text').prop('disabled', true);

                if (actualText != '' & loadingText != '') {
                    $('[type="submit"]', element).text(loadingText);
                }
            }else{
                $(element).removeClass('processing');
                $('[type="submit"]', element).prop('disabled', false);
                if($(element).prop('tagName').toLowerCase() =='a'){
                    $(element).prop('disabled', false);
                }else{
                    $('[type="button"]', element).prop('disabled', false);
                    $('[type="submit"]', element).prop('disabled', false);
                    $('[type="reset"]', element).prop('disabled', false);
                }

                $('#text').prop('disabled', false);

                if (actualText != '' & loadingText != '') {
                    $('[type="submit"]', element).text(actualText);
                }
            }
        }

        act.respond = function(element, json){
 
            if (json.errors) {
                $('.is-invalid').removeClass('is-invalid');
                $('.invalid-feedback').remove();
                $.each(json.errors, function (name, errors) {
                    var nameSplit = name.split('.');
                    var field = nameSplit.length == 1 ? name : (nameSplit[0] + '[' + nameSplit.splice(1).join('][') + ']');
                    $("[name='" + field + "']", element).addClass("is-invalid");
                    $("[name='" + field + "']", element).closest('div').append( $('<div/>').addClass('invalid-feedback').html(errors[0]));
                    $("[name='" + field + "']", element).closest('div').find('.invalid-feedback').show();
                    $("[name='" + field + "']", element).on('change', function(){
                        $(this).removeClass('is-invalid').closest('div').find('.invalid-feedback').remove();
                    });
                });

                if ($('.invalid-feedback')[0]){
                    $("html,body").animate({scrollTop: $('.invalid-feedback').offset().top - 80, scrollLeft: 0},300);
                } 
            }
 
            if (json.jquery) {
                if (json.jquery.element && json.jquery.method) {
                  if (json.jquery.value !== undefined) {
                    if (Array.isArray(json.jquery.value)) {
                      $(json.jquery.element)[json.jquery.method](...json.jquery.value);
                    } else {
                      $(json.jquery.element)[json.jquery.method](json.jquery.value);
                      if(json.jquery.method == 'html'){
                        settings.init(json.jquery.element);
                      }
                    }
                  } else {
                    $(json.jquery.element)[json.jquery.method]();
                  }
                } else {
                  $.each(json.jquery, function (index, uiTarget) {
                    if (uiTarget.element && uiTarget.method) {
                      if (uiTarget.value !== undefined) {
                        if (Array.isArray(uiTarget.value)) {
                          $(uiTarget.element)[uiTarget.method](...uiTarget.value);
                        } else {
                          $(uiTarget.element)[uiTarget.method](uiTarget.value);
                          if(uiTarget.method == 'html'){
                            settings.init(uiTarget.element);
                          }
                        }
                      } else {
                        $(uiTarget.element)[uiTarget.method]();
                      }
                    }
                  });
                }
            }
 
            settings.respond(act,element, json);

            if (json.toast) {
                $('#toast .message .content').html(json.toast.message);
                $('#toast').addClass(json.toast.icon);
                $('#toast').addClass('active');
              
                setTimeout(function() {
                  $('#toast .message .content').html('');
                  $('#toast').removeClass(json.toast.icon);
                  $('#toast').removeClass('active');
                }, 2000);
            }   
 
            if (json.alert) {
                let swalconfig = {
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                }

                Object.assign(swalconfig, json.alert)

                Swal.fire(swalconfig).then(function(result) {
                    if(json.alert.redirect){
                        window.location.href = json.alert.redirect;
                    } 
                });
            }  

            if (json.razorpay && json.razorpay.option && json.razorpay.response) {
                var url = json.razorpay.response;
        
                json.razorpay.option['handler'] = function (response) {
                    var data = new FormData();
                    data.append('payment_id', response.razorpay_payment_id);
                    data.append('order_id', response.razorpay_order_id);
                    data.append('signature', response.razorpay_signature);
        
                    fetch(url, {
                        headers: settings.headers,
                        method: 'POST',
                        body: data,
                        cache: 'no-cache',
                    })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.json();
                    })
                    .then(json => {
                        act.respond(element, json);
                    })
                    .catch(error => {
                        console.error('Error during Razorpay handler:', error);
                    });
                };

                var razorpayCheckout = new Razorpay(json.razorpay.option);
                
                razorpayCheckout.on('payment.failed', function (response){
                    var data = new FormData();
                    data.append('payment_id', response.error.metadata.payment_id);
                    data.append('order_id', response.error.metadata.order_id);
                    data.append('signature', null);
        
                    fetch(url, {
                        headers: settings.headers,
                        method: 'POST',
                        body: data,
                        cache: 'no-cache',
                    })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.json();
                    })
                    .then(json => {
                        act.respond(element, json);
                    })
                    .catch(error => {
                        console.error('Error during Razorpay handler:', error);
                    });
                });
        
                razorpayCheckout.open();
            }

            if (json.redirect) {
                window.location.href = json.redirect;
            }

            if (json.reload) {
                location.reload()
            }
        };

        act.request = async function (element, url, data) {

            async function asyncCall(element, url, data, attempt = 1) {

                act.loading(element, true);

                $('.is-invalid').removeClass('is-invalid');
                $('.invalid-feedback').remove();

                var retry = false;

                try {
                    const response = await fetch(url, {
                        headers: settings.headers,
                        method: 'POST',
                        body: data,
                        cache: 'no-cache',
                    });
        
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }

                    const json = await response.json();
                    act.respond(element, json);
                    if(json.retry){
                        retry = true
                    }
                    
                } catch (error) {

                    if (attempt < 1) {
                        await new Promise(resolve => setTimeout(resolve, 10000));
                        await asyncCall(element, url, data, attempt + 1);
                    }
                }  
                
                if(retry){
                    await new Promise(resolve => setTimeout(resolve, 10000));
                    await asyncCall(element, url, data, attempt + 1);   
                }else{
                    act.loading(element, false);
                }
                
            }
    
            await asyncCall(element, url, data);
        };

        act.on = function(element, action){
            let data = false;
            if(action == 'submit'){
                data = new FormData(element);
            }else{
                data = new FormData();

                if ($(element).is('div')) {
                    if($(element).hasClass('ql-container')){
                        data.append('value', $(element).find('.ql-editor').html());
                    }else{
                        data.append('value', $(element).html());
                    }
                } else {
                    if ($(element).val()) {
                        data.append('value', $(element).val());
                    }   
                }
            }

            $.each(element.attributes, function() {
                if (this.name.startsWith('data-')) {
                    let attributeName = this.name.substring(5); 
                    data.append(attributeName, this.value);
                }
            });
      
            if($(element).attr("act-with")){  
                
                let actWith = $(element).attr("act-with");

                $(element).closest('[act-group="' + actWith + '"]').find('[act-related="' + actWith + '"]').each(function(){
                    if( $(element).attr('name') != $(this).attr('name') ){
                        data.append('related[' + $(this).attr('name') + ']', $(this).val());
                    }
                });
            }

            if($(element).attr("act-request")){     
                let request = $(element).attr('act-request');
                act.request(element, request, data)
            }

            if($(element).attr("act-respond") && !$(element).attr("act-request")){      
                let respond = $(element).attr('act-respond');  
                try {
                    act.respond(element, JSON.parse(respond));
                }catch(err) {
                    if($(element).attr('name')){
                        console.error('Invalid input ' + $(element).attr('name') + ' act-respond json');
                        console.error(err);
                    }else{
                        console.error(err);
                    }
                }
            }
        }

        act.events = ['submit', 'blur', 'change', 'click', 'dblclick', 'drop', 'focus', 'focusin', 'focusout',  'keydown', 'keypress', 'keyup', 'load', 'mousedown', 'mouseenter', 'mouseleave', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'paste', 'resize', 'scroll' ];
        var debounceTimers = {};

        act.events.forEach(actEvent => {
            $(this).on(actEvent, `[act-on=${actEvent}]`, function(event) {

                if( $(this).attr('act-confirm') ){

                    Swal.fire({
                        title: 'Are you sure?',
                        text: $(this).attr('act-confirm'),
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#757575',
                        cancelButtonText: 'Yes, Proceed',
                        cancelButtonColor: '#b40606',
                        confirmButtonText: 'Cancel'
                      }).then((result) => {
                            if(result.dismiss === 'cancel'){
                                act.on(this, actEvent);
                            }   
                      });
                      
                }else{
                    
                    if (['keydown', 'keypress', 'keyup'].includes(actEvent)) {
                        if (debounceTimers[actEvent]) {
                            clearTimeout(debounceTimers[actEvent]);
                        }
                        
                        debounceTimers[actEvent] = setTimeout(() => {
                            act.on(this, actEvent);
                        }, 500);
                    } else {
                        event.preventDefault();
                        act.on(this, actEvent);
                    }

                }
            });
        });

        return act;
    }
});


